// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LrxJT","top":"styles_top__M_uBZ"};